import APIService from '../api.service';

export const List = (params) => {
  return APIService.get(`/v01/suppliers`, {
    params: {
      per_page: params.perPage,
      page: params.page,
      keyword: params.keyword,
    },
  });
};

export const Create = (body, config = {}) => {
  return APIService.post(`/v01/suppliers`, body, config);
};

export const Put = (payload, config = {}) => {
  const { id } = payload;
  return APIService.put(`/v01/suppliers/${id}`, {...payload}, config);
};

export const Delt = (id, config = {}) => {
  return APIService.delete(`/v01/suppliers/${id}`, config);
};

export const All = () => {
  return APIService.get(`/v01/suppliers/all`);
};

const SupplierService = {
  List,
  Create,
  Put,
  Delt,
  All
};
export default SupplierService;
